namespace $.$$ {

	$mol_style_define( $shm_projects_goal_demo, {

		flex: { direction: 'column' },
		gap: $mol_gap.text,
		minWidth: 0,

		Open: {
			alignSelf: 'flex-start',
		},

		Frame: {
			width: '100%',
			height: '32rem',
			border: {
				width: '1px',
				style: 'solid',
				color: $mol_theme.line,
				radius: $mol_gap.round,
			},
		},

	} )

}
